module.exports = __webpack_public_path__ + "static/media/Company-Info.7716d91e.svg";